export const pay_setting_btn_link={
    bulksmsbd: "/sms-setting/bulksmsbd",
    mimsms: "/sms-setting/mimsms",
    smsq: "/sms-setting/smsq",
    alpha: "/sms-setting/alpha",

}